
  var _styles = {
  "current-position-top-text-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "height": "0.53333rem",
    "marginTop": "0.48rem",
    "marginRight": "0.32rem",
    "marginBottom": "0.26667rem",
    "marginLeft": 0
  },
  "current-position-refresh-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "current-position-little-icon": {
    "width": "0.37333rem",
    "height": "0.37333rem",
    "marginRight": "0.10667rem"
  },
  "current-position-blue-text": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.32rem",
    "color": "rgb(0,64,153)",
    "letterSpacing": 0,
    "lineHeight": "0.32rem"
  },
  "current-position-location-name-container": {
    "display": "flex",
    "flexDirection": "row",
    "marginLeft": "0.42667rem"
  },
  "current-position-location-name": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(32,32,32)",
    "letterSpacing": 0,
    "lineHeight": "0.37333rem"
  },
  "current-position-precise-name": {
    "marginTop": "0.16rem",
    "marginLeft": "0.90667rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(153,153,153)",
    "letterSpacing": 0,
    "lineHeight": "0.32rem"
  },
  "current-position-city-name-margin": {
    "marginTop": "0.21333rem",
    "marginRight": 0,
    "marginBottom": "0.64rem",
    "marginLeft": "0.45333rem"
  },
  "city-selection-little-gray-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(34,34,34)",
    "letterSpacing": 0,
    "lineHeight": "0.53333rem",
    "fontWeight": "400"
  }
};



  module.exports = _styles;
  